import { render, staticRenderFns } from "./PCDetail.vue?vue&type=template&id=a32d31fc&scoped=true&"
import script from "./PCDetail.vue?vue&type=script&lang=js&"
export * from "./PCDetail.vue?vue&type=script&lang=js&"
import style0 from "./PCDetail.vue?vue&type=style&index=0&id=a32d31fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32d31fc",
  null
  
)

export default component.exports